module.exports = __webpack_public_path__ + "static/media/jt1.e8623cb8.png";